!function () {
    let resizeAF = null;
    let resizeTimer = null;

    app.bind('default resize window-resize', function (context) {
        if ( resizeAF ) {
            clearTimeout(resizeTimer);
            cancelAnimationFrame(resizeAF);
        }
        const $window = $(window);
        let windowWidth;
        let windowHeight;
        let bodyHeight;
        let windowWidthWas;
        let windowHeightWas;
        let bodyHeightWas;

        const resizeCallback = (timestamp) => {
            windowWidth = window.innerWidth;
            windowHeight = window.innerHeight;
            bodyHeight = document.body.scrollHeight;
            if ( windowWidth != windowWidthWas || windowHeight != windowHeightWas || bodyHeight != bodyHeightWas) {
                windowWidthWas = windowWidth;
                windowHeightWas = windowHeight;
                bodyHeightWas = bodyHeight;

                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    $window.trigger('windowResized', {
                        windowWidth: windowWidth,
                        windowHeight: windowHeight,
                    });
                }, 250);
            }

            resizeAF = requestAnimationFrame(resizeCallback);
        };
        resizeAF = requestAnimationFrame(resizeCallback);
    }, -500);
}();
